module.exports = __webpack_public_path__ + "fonts/KaTeX_Main-Regular.f8a7f19f.woff2";